const common = {
  "nav.categories": "Categorías",
  "nav.guides": "Guías",
  "nav.about": "Acerca de",
  "nav.faq": "Preguntas",
  "nav.cta": "Comprar ahora",
  "nav.home": "Inicio",
  "nav.shoppingGuide": "Guía de compra",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",

  "hero.badge": "Centro de recursos de Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet: productos, vendedores y guías de compra",
  "hero.subtitle":
    "Un centro de recursos independiente y limpio que te ayuda a explorar categorías de productos de Basetao, enlaces seleccionados y consejos prácticos de compra, todo en un solo lugar.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Comprar ahora",
  "hero.dropdownLabel": "Ir a una categoría",

  "cat.dropdownPlaceholder": "Elige una categoría…",

  "catSection.eyebrow": "Compra en el spreadsheet",
  "catSection.title": "Explorar categorías",
  "catSection.subtitle":
    "Explora las categorías de productos más populares del Basetao Spreadsheet y accede directamente a los artículos que buscas.",
  "catSection.shopNow": "Comprar",

  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorras y sombreros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior",
  "cat.jersey": "Camisetas deportivas",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otros artículos",

  "guides.eyebrow": "Guías y recursos",
  "guides.title": "Guías populares",
  "guides.subtitle":
    "Artículos originales y prácticos que explican cómo usar el Basetao Spreadsheet y comprar con confianza.",
  "guides.readMore": "Leer la guía",
  "guides.card.badge": "Guía para principiantes",
  "guides.card.title": "Guía del Basetao Spreadsheet: qué es y cómo usarlo",
  "guides.card.excerpt":
    "Una guía clara y apta para principiantes sobre qué es un Basetao Spreadsheet, cómo leerlo y cómo usarlo para encontrar productos, vendedores y mejores precios.",

  "about.eyebrow": "¿Qué es?",
  "about.title": "¿Qué es un Basetao Spreadsheet?",
  "about.p1":
    "Un Basetao Spreadsheet es una lista compartida y organizada de productos, enlaces, vendedores y notas que recopilan los compradores que usan Basetao para pedir en marketplaces chinos y enviar internacionalmente. En lugar de buscar desde cero, partes de un conjunto seleccionado de artículos que otros compradores ya han encontrado y revisado.",
  "about.p2":
    "Como una hoja de cálculo es fácil de filtrar, ordenar y compartir, es una forma práctica de comparar productos en categorías como zapatos, sudaderas, camisetas, chaquetas, bolsos y accesorios, y de llevar un registro de los vendedores y las notas de control de calidad que importan al pedir.",
  "about.point1.title": "Productos seleccionados",
  "about.point1.text":
    "Los enlaces a artículos concretos están organizados por categoría, para que pases menos tiempo buscando y más comparando.",
  "about.point2.title": "Notas de vendedores y QC",
  "about.point2.text":
    "Notas útiles sobre vendedores y observaciones de control de calidad te ayudan a detectar opciones fiables antes de pedir.",
  "about.point3.title": "Compartible y actualizable",
  "about.point3.text":
    "Las hojas de cálculo son fáciles de compartir y actualizar, para que la lista se mantenga fresca a medida que se añaden productos y notas.",

  "features.eyebrow": "Por qué usarlo",
  "features.title": "¿Por qué usar un Basetao Spreadsheet?",
  "features.subtitle":
    "Algunas razones por las que los compradores confían en una hoja de cálculo organizada al pedir a través de Basetao.",
  "features.f1.title": "Ahorra tiempo",
  "features.f1.text": "Parte de una lista lista en lugar de navegar por decenas de páginas una a una.",
  "features.f2.title": "Compara fácilmente",
  "features.f2.text": "Ve productos lado a lado por categorías, vendedores y precios.",
  "features.f3.title": "Mantente organizado",
  "features.f3.text": "Guarda tus favoritos, notas y detalles de control de calidad en un solo lugar ordenado.",
  "features.f4.title": "Compra con contexto",
  "features.f4.text":
    "Combina enlaces de productos con notas de vendedores y QC para tomar decisiones más seguras.",

  "faq.eyebrow": "Preguntas",
  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es un Basetao Spreadsheet?",
  "faq.a1":
    "Es una lista compartida y organizada de productos, enlaces, vendedores y notas que los compradores usan para encontrar y comparar artículos pedidos a través de Basetao.",
  "faq.q2": "¿Este sitio está afiliado a Basetao?",
  "faq.a2":
    "No. BasetaoSheet.casa es un recurso informativo independiente y no está necesariamente afiliado a Basetao salvo que se indique explícitamente.",
  "faq.q3": "¿Cómo uso las categorías de esta página?",
  "faq.a3":
    "Elige una categoría en el menú desplegable o en la cuadrícula y serás llevado a la página de producto correspondiente en nuestro sitio principal.",
  "faq.q4": "¿Necesito una cuenta para navegar?",
  "faq.a4": "No, puedes explorar las categorías y guías libremente sin registrarte.",
  "faq.q5": "¿Los precios y vendedores están garantizados?",
  "faq.a5":
    "Los precios, la disponibilidad y los datos de los vendedores pueden cambiar. Revisa siempre la página del producto en el sitio principal antes de pedir.",

  "cta.title": "¿Listo para explorar todo el catálogo?",
  "cta.subtitle": "Navega por todas las categorías en el sitio principal y encuentra los artículos que buscas.",
  "cta.button": "Comprar ahora",

  "footer.tagline":
    "Basetao Sheet es un centro de recursos independiente para el Basetao Spreadsheet, que ayuda a los compradores a explorar productos, categorías y guías.",
  "footer.disclaimer": "Recurso informativo independiente. No necesariamente afiliado a Basetao.",
  "footer.explore": "Explorar",
  "footer.resources": "Recursos",
  "footer.legal": "Legal",
  "footer.guide": "Guía del Spreadsheet",
  "footer.home": "Inicio",
  "footer.categories": "Categorías",
  "footer.about": "Acerca de",
  "footer.faq": "Preguntas",
  "footer.rights": "Todos los derechos reservados.",

  "home.breadcrumb": "Inicio",
  "article.notFound": "Artículo no encontrado",
  "article.faqHeading": "Preguntas frecuentes",
  "article.conclusionHeading": "Conclusión",

  "notFound.title": "Página no encontrada",
  "notFound.subtitle": "La página que buscas no existe o puede haber sido movida.",
};

export default common;